import React, { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { Lock } from "lucide-react";
import { useApp } from "../../context/AppContext";
import { toast } from "sonner";

const AdminLogin = () => {
    const { login, t } = useApp();
    const navigate = useNavigate();
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [loading, setLoading] = useState(false);

    const submit = async (e) => {
        e.preventDefault();
        setLoading(true);
        try {
            await login(email, password);
            toast.success("Giriş başarılı");
            navigate("/admin");
        } catch (err) {
            const detail = err.response?.data?.detail;
            toast.error(typeof detail === "string" ? detail : "Giriş başarısız");
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="min-h-screen bg-emerald_deep arabesque-pattern flex items-center justify-center px-6">
            <div className="w-full max-w-md">
                <Link to="/" className="flex items-center justify-center gap-3 mb-8">
                    <img src="/assets/asis-icon.png" alt="ASİS HOTELS" className="w-16 h-16 object-contain" />
                    <div className="font-serif text-2xl font-semibold text-gold tracking-wider">{t("brand")}</div>
                </Link>

                <form onSubmit={submit} className="border border-border_green bg-emerald_surface p-10">
                    <div className="ornament-divider mb-6"><Lock className="w-4 h-4" /></div>
                    <h1 className="font-serif text-3xl mb-2 text-center">{t("admin.login_title")}</h1>
                    <p className="text-xs text-muted_green text-center mb-8 tracking-wider">SADECE YETKİLİ ERİŞİM</p>

                    <div className="space-y-4">
                        <div>
                            <label className="label-dark">Kullanıcı Adı</label>
                            <input type="text" required value={email} onChange={(e) => setEmail(e.target.value)} className="input-dark" placeholder="kullanıcı adınız" data-testid="admin-email-input" autoComplete="username" />
                        </div>
                        <div>
                            <label className="label-dark">{t("admin.password")}</label>
                            <input type="password" required value={password} onChange={(e) => setPassword(e.target.value)} className="input-dark" data-testid="admin-password-input" autoComplete="current-password" />
                        </div>
                    </div>

                    <button type="submit" disabled={loading} className="btn-gold w-full mt-8" data-testid="admin-login-submit">
                        {loading ? "..." : t("admin.login")}
                    </button>

                    <Link to="/" className="block text-center text-xs uppercase tracking-[0.2em] text-muted_green hover:text-gold mt-6">
                        ← Ana Sayfa
                    </Link>
                </form>
            </div>
        </div>
    );
};

export default AdminLogin;
